import { controllerFactory } from "@utils/createController";
import { Turbo } from "@hotwired/turbo-rails";

export default class PollController extends controllerFactory<HTMLDivElement>()(
  {
    values: {
      url: String,
    },
  },
) {
  headers = {
    Accept: "text/vnd.turbo-stream.html",
  };
  connect() {
    setInterval(() => {
      fetch(this.urlValue, { headers: this.headers })
        .then((response) => response.text())
        .then((html) => Turbo.renderStreamMessage(html));
    }, 2500);
  }
}
